import React from 'react';
import PropTypes from 'prop-types';
import utils from 'helpers/utils';
import { getRuleComponentByType } from 'helpers/rulesHelper';

function RuleListItemConfiguration(props) {
    const {
        onUpdate,
        rule,
    } = props;

    const {
        config,
        id,
        type,
    } = rule;

    const component = getRuleComponentByType(utils.firstCharToLowerCase(rule.type));

    if (!component) {
        return null;
    }

    return React.createElement(component, {
        id: id,
        onUpdate: onUpdate,
        type: type,
        value: config,
    });
}

RuleListItemConfiguration.propTypes = {
    onUpdate: PropTypes.func,
    rule: PropTypes.shape({
        config: PropTypes.shape({
            attribute: PropTypes.string,
            operator: PropTypes.string,
            value: PropTypes.oneOfType([
                PropTypes.array,
                PropTypes.bool,
                PropTypes.number,
                PropTypes.object,
                PropTypes.string,
            ]),
        }),
        id: PropTypes.string,
        open: PropTypes.bool,
        type: PropTypes.string,
    }),
};

export default RuleListItemConfiguration;



// WEBPACK FOOTER //
// ./src/pages/discounts/rules/RuleListItemConfiguration.js